/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SingleOrbitRequest {
  radius: number;
  globalMapTCenter: Vector3dPb | undefined;
  gimbalPitch: number;
  numPhotos: number;
  lookOutwards: boolean;
  counterClockwise: boolean;
}

function createBaseSingleOrbitRequest(): SingleOrbitRequest {
  return {
    radius: 0,
    globalMapTCenter: undefined,
    gimbalPitch: 0,
    numPhotos: 0,
    lookOutwards: false,
    counterClockwise: false,
  };
}

export const SingleOrbitRequest = {
  encode(message: SingleOrbitRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.radius !== 0) {
      writer.uint32(9).double(message.radius);
    }
    if (message.globalMapTCenter !== undefined) {
      Vector3dPb.encode(message.globalMapTCenter, writer.uint32(18).fork()).ldelim();
    }
    if (message.gimbalPitch !== 0) {
      writer.uint32(25).double(message.gimbalPitch);
    }
    if (message.numPhotos !== 0) {
      writer.uint32(32).uint32(message.numPhotos);
    }
    if (message.lookOutwards === true) {
      writer.uint32(40).bool(message.lookOutwards);
    }
    if (message.counterClockwise === true) {
      writer.uint32(48).bool(message.counterClockwise);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SingleOrbitRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSingleOrbitRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.radius = reader.double();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.globalMapTCenter = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.gimbalPitch = reader.double();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.numPhotos = reader.uint32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lookOutwards = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.counterClockwise = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SingleOrbitRequest {
    return {
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
      globalMapTCenter: isSet(object.globalMapTCenter) ? Vector3dPb.fromJSON(object.globalMapTCenter) : undefined,
      gimbalPitch: isSet(object.gimbalPitch) ? globalThis.Number(object.gimbalPitch) : 0,
      numPhotos: isSet(object.numPhotos) ? globalThis.Number(object.numPhotos) : 0,
      lookOutwards: isSet(object.lookOutwards) ? globalThis.Boolean(object.lookOutwards) : false,
      counterClockwise: isSet(object.counterClockwise) ? globalThis.Boolean(object.counterClockwise) : false,
    };
  },

  toJSON(message: SingleOrbitRequest): unknown {
    const obj: any = {};
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    if (message.globalMapTCenter !== undefined) {
      obj.globalMapTCenter = Vector3dPb.toJSON(message.globalMapTCenter);
    }
    if (message.gimbalPitch !== 0) {
      obj.gimbalPitch = message.gimbalPitch;
    }
    if (message.numPhotos !== 0) {
      obj.numPhotos = Math.round(message.numPhotos);
    }
    if (message.lookOutwards === true) {
      obj.lookOutwards = message.lookOutwards;
    }
    if (message.counterClockwise === true) {
      obj.counterClockwise = message.counterClockwise;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SingleOrbitRequest>, I>>(base?: I): SingleOrbitRequest {
    return SingleOrbitRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SingleOrbitRequest>, I>>(object: I): SingleOrbitRequest {
    const message = createBaseSingleOrbitRequest();
    message.radius = object.radius ?? 0;
    message.globalMapTCenter = (object.globalMapTCenter !== undefined && object.globalMapTCenter !== null)
      ? Vector3dPb.fromPartial(object.globalMapTCenter)
      : undefined;
    message.gimbalPitch = object.gimbalPitch ?? 0;
    message.numPhotos = object.numPhotos ?? 0;
    message.lookOutwards = object.lookOutwards ?? false;
    message.counterClockwise = object.counterClockwise ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
